import { useAuth } from '@auth';
import { useLocation, useSearchParams } from 'wouter';
import { SplashScreen } from '@/components/SplashScreen';
import { useEffect } from 'react';

export default function Login() {
  const { signIn, isLoading, user } = useAuth();
  const [searchParams] = useSearchParams();
  const [, setLocation] = useLocation();

  let returnURI = searchParams.get('returnURI');
  returnURI = returnURI === '/login' ? '/' : returnURI;

  useEffect(() => {
    if (isLoading) {
      return;
    }
    if (user) {
      setLocation(returnURI ?? '/');
      return;
    }
    signIn({ state: { returnTo: returnURI } });
  }, [isLoading, returnURI, signIn, user, setLocation]);

  return <SplashScreen />;
}
